const s = (e, o) => {
  const l = /\$\{\{ *([A-Za-z0-9_.]+) *\}\}/g;
  return e.replace(l, (r, t) => {
    const c = t.split(".").pop() || t, n = o.find((p) => p.key === c);
    return n?.default || r;
  });
};
export {
  s as replaceParamsInTitle
};
//# sourceMappingURL=replaceParamsInTitle.es.js.map
